// ── Shared rep customers store — syncs rep route customers between rep portal & admin ──
// When rep adds/edits/removes customers in route planner → admin sees it in Reps tab.
// When admin views a rep's customers → sees live data from rep portal.
// Keyed by rep name (e.g. "Marcus T.") — stores { customers: [], prospects: [] }

const LS_KEY = "mpcare_shared_rep_customers";

function load() {
  try { const raw = localStorage.getItem(LS_KEY); if (raw) return JSON.parse(raw); } catch (e) {}
  return {};
}

function save(data) {
  try { localStorage.setItem(LS_KEY, JSON.stringify(data)); } catch (e) {}
}

const SHARED_REP_CUSTOMERS = {
  _data: load(),   // keyed by rep name
  _subs: [],

  /** Get customers + prospects for a specific rep */
  get(repName) {
    return this._data[repName] || null;
  },

  /** Get all rep customer data */
  getAll() {
    return { ...this._data };
  },

  /** Set/update a rep's customer list (called from rep portal when customers change) */
  set(repName, data) {
    this._data[repName] = {
      ...(this._data[repName] || {}),
      ...data,
      updatedAt: new Date().toISOString()
    };
    save(this._data);
    this._notify();
  },

  /** Subscribe to changes */
  subscribe(fn) {
    this._subs.push(fn);
    return () => { this._subs = this._subs.filter(f => f !== fn); };
  },

  _notify() {
    const data = { ...this._data };
    this._subs.forEach(fn => { try { fn(data); } catch (e) {} });
  }
};

export default SHARED_REP_CUSTOMERS;
